import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GlobalStore } from './reduxStore';
import { sendVirtualPageView } from './services/ga4/GoogleAnalyticsEvents';
import { setGa4User } from './services/ga4/ga4Bootstrap';

// GA4 SPA tracker (gtag is configured with send_page_view:false):
//  - fires virtual_pageview on every route change
//  - sets user_id once the customer is known, so the same person stitches across
//    www.24rent.fi <-> m.24rent.fi in the shared GA4 property
const Ga4Tracker = () => {
    const { pathname, search } = useLocation();
    const userId = useSelector((s: GlobalStore) => s.chauffeurReducer.user?.id);

    useEffect(() => {
        if (userId != null) setGa4User({ id: userId });
    }, [userId]);

    useEffect(() => {
        sendVirtualPageView(pathname + (search || ''));
    }, [pathname, search]);

    return null;
}

export default Ga4Tracker;
